module.exports = {"loader":"Generating export","error":"Export error","success":"Export <b>{fileName}</b> was successfully generated"}